/**
 * ReplyPreview - a faixa acima do composer quando o operador escolheu
 * "Responder" numa mensagem (ou "Editar" a própria): mostra a prévia e o X
 * para cancelar. Compartilhado pelos 3 shells.
 *
 * Props: { mode: 'reply'|'edit', quoted (bloco quoted), contactName,
 *          colors, onCancel }
 */
import React from 'react';
import { X, Reply, Pencil } from 'lucide-react';
import QuotedMessage from './QuotedMessage';

const ReplyPreview = ({ mode = 'reply', quoted, contactName, colors, onCancel }) => {
  if (!quoted) return null;
  const isEdit = mode === 'edit';
  const Icon = isEdit ? Pencil : Reply;
  return (
    <div style={{
      display: 'flex', alignItems: 'center', gap: 10,
      padding: '8px 12px 0 12px', backgroundColor: colors.bgPrimary,
    }}>
      <Icon size={18} color={colors.accentPrimary} style={{ flexShrink: 0 }} />
      <div style={{ flex: 1, minWidth: 0 }}>
        {isEdit && (
          <div style={{ fontSize: 11, color: colors.textTertiary, marginBottom: 2 }}>
            Editando mensagem
          </div>
        )}
        <div style={{ marginBottom: -6 }}>
          <QuotedMessage quoted={quoted} contactName={contactName} colors={colors} />
        </div>
      </div>
      <button
        type="button"
        onClick={onCancel}
        title={isEdit ? 'Cancelar edição' : 'Cancelar resposta'}
        style={{
          width: 30, height: 30, borderRadius: '50%', border: 'none',
          backgroundColor: 'transparent', color: colors.textSecondary, cursor: 'pointer',
          display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0,
        }}
      >
        <X size={18} />
      </button>
    </div>
  );
};

export default ReplyPreview;
